"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MeetingSessionStatus_1 = require("../meetingsession/MeetingSessionStatus");

var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");

var DefaultSDP_1 = require("../sdp/DefaultSDP");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var SignalingClientSubscribe_1 = require("../signalingclient/SignalingClientSubscribe");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var BaseTask_1 = require("./BaseTask");
/**
 * [[SubscribeAndReceiveSubscribeAckTask]] sends a subscribe frame with the given settings
 * and receives SdkSubscribeAckFrame.
 */


var SubscribeAndReceiveSubscribeAckTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(SubscribeAndReceiveSubscribeAckTask, _BaseTask_1$default);

  var _super = _createSuper(SubscribeAndReceiveSubscribeAckTask);

  function SubscribeAndReceiveSubscribeAckTask(context) {
    var _this;

    _classCallCheck(this, SubscribeAndReceiveSubscribeAckTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'SubscribeAndReceiveSubscribeAckTask';
    _this.taskCanceler = null;
    return _this;
  }

  _createClass(SubscribeAndReceiveSubscribeAckTask, [{
    key: "cancel",
    value: function cancel() {
      if (this.taskCanceler) {
        this.taskCanceler.cancel();
        this.taskCanceler = null;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var localSdp, frameRate, maxEncodeBitrateKbps, param, isSendingStreams, subscribe, subscribeAckFrame;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localSdp = '';

                if (this.context.peer && this.context.peer.localDescription) {
                  if (this.context.browserBehavior.requiresUnifiedPlanMunging()) {
                    localSdp = new DefaultSDP_1.default(this.context.peer.localDescription.sdp).withUnifiedPlanFormat().sdp;
                  } else {
                    localSdp = this.context.peer.localDescription.sdp;
                  }
                }

                if (!this.context.enableSimulcast) {
                  // backward compatibility
                  frameRate = 0;
                  maxEncodeBitrateKbps = 0;

                  if (this.context.videoCaptureAndEncodeParameter) {
                    frameRate = this.context.videoCaptureAndEncodeParameter.captureFrameRate();
                    maxEncodeBitrateKbps = this.context.videoCaptureAndEncodeParameter.encodeBitrates()[0];
                  }

                  param = {
                    rid: 'hi',
                    maxBitrate: maxEncodeBitrateKbps * 1000,
                    maxFramerate: frameRate,
                    active: true
                  };
                  this.context.videoStreamIndex.integrateUplinkPolicyDecision([param]);
                }

                this.context.videoStreamIndex.subscribeFrameSent();
                isSendingStreams = this.context.videoDuplexMode === SignalingProtocol_js_1.SdkStreamServiceType.TX || this.context.videoDuplexMode === SignalingProtocol_js_1.SdkStreamServiceType.DUPLEX;
                this.context.previousSdpOffer = new DefaultSDP_1.default(localSdp);
                subscribe = new SignalingClientSubscribe_1.default(this.context.meetingSessionConfiguration.credentials.attendeeId, localSdp, this.context.meetingSessionConfiguration.urls.audioHostURL, this.context.realtimeController.realtimeIsLocalAudioMuted(), false, this.context.videoSubscriptions, isSendingStreams, this.context.videoStreamIndex.localStreamDescriptions(), // TODO: handle check-in mode, or remove this param
                true);
                this.context.logger.info("sending subscribe: ".concat(JSON.stringify(subscribe)));
                this.context.signalingClient.subscribe(subscribe);
                _context.next = 11;
                return this.receiveSubscribeAck();

              case 11:
                subscribeAckFrame = _context.sent;
                this.context.logger.info("got subscribe ack: ".concat(JSON.stringify(subscribeAckFrame)));
                this.context.sdpAnswer = subscribeAckFrame.sdpAnswer;
                this.context.videoStreamIndex.integrateSubscribeAckFrame(subscribeAckFrame);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "receiveSubscribeAck",
    value: function receiveSubscribeAck() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var context = _this2.context;

        var Interceptor = /*#__PURE__*/function () {
          function Interceptor(signalingClient) {
            _classCallCheck(this, Interceptor);

            this.signalingClient = signalingClient;
          }

          _createClass(Interceptor, [{
            key: "cancel",
            value: function cancel() {
              this.signalingClient.removeObserver(this);
              reject(new Error("SubscribeAndReceiveSubscribeAckTask got canceled while waiting for SdkSubscribeAckFrame"));
            }
          }, {
            key: "handleSignalingClientEvent",
            value: function handleSignalingClientEvent(event) {
              if (event.isConnectionTerminated()) {
                var message = "SubscribeAndReceiveSubscribeAckTask connection was terminated with code ".concat(event.closeCode, " and reason: ").concat(event.closeReason);
                context.logger.warn(message);
                var statusCode = MeetingSessionStatusCode_1.default.TaskFailed;

                if (event.closeCode >= 4500 && event.closeCode < 4600) {
                  statusCode = MeetingSessionStatusCode_1.default.SignalingInternalServerError;
                }

                context.audioVideoController.handleMeetingSessionStatus(new MeetingSessionStatus_1.default(statusCode), new Error(message));
                return;
              }

              if (event.type !== SignalingClientEventType_1.default.ReceivedSignalFrame || event.message.type !== SignalingProtocol_js_1.SdkSignalFrame.Type.SUBSCRIBE_ACK) {
                return;
              }

              this.signalingClient.removeObserver(this); // @ts-ignore: force cast to SdkSubscribeAckFrame

              var subackFrame = event.message.suback;
              resolve(subackFrame);
            }
          }]);

          return Interceptor;
        }();

        var interceptor = new Interceptor(_this2.context.signalingClient);

        _this2.context.signalingClient.registerObserver(interceptor);

        _this2.taskCanceler = interceptor;
      });
    }
  }]);

  return SubscribeAndReceiveSubscribeAckTask;
}(BaseTask_1.default);

exports.default = SubscribeAndReceiveSubscribeAckTask;